import { tv } from "tailwind-variants";

import { monsterrat } from "@/services/styles/fonts";

export const getFooterClass = tv({
  base: "mx-auto max-w-[375px] animate-duration-300 animate-fade bg-white lg:max-w-none lg:border-t lg:pt-20",
});

export const getCompanyMetaWrapperClass = tv({ base: ["font-semibold text-gray-600 text-sm", monsterrat.className] });

export const getColumnItemLinkClass = tv({
  base: [monsterrat.className, "font-semibold text-primary-900 text-sm"],
});

export const getTermsLinkClass = tv({ base: [monsterrat.className, "font-semibold text-primary-900"] });
